import { PropTypes } from 'prop-types';
import { useSelector } from 'react-redux';
import { getIsMobileApp } from 'store/ui/uiSelectors';

const MobileAppBoundary = ({ children }) => {
  const isMobileApp = useSelector(getIsMobileApp);
  return isMobileApp ? null : children;
};

MobileAppBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default MobileAppBoundary;
